import { css } from 'styled-components';

const TOKENS = [
  '00',
  '100',
  '200',
  '300',
  '400',
  '500',
  '600',
  '700',
  '800',
  '900',
  '1000',
  '1100',
  '1200',
];

const SIZE_MAP = {
  poster: { xlarge: '1200', large: '1100', medium: '1000', small: '900' },
  display: { large: '1000', medium: '900', small: '800' },
  headline: { large: '700', medium: '600', small: '500' },
  title: { large: '400', medium: '300', small: '200' },
  body: { large: '300', medium: '200', small: '100', xsmall: '00' },
  label: { large: '300', medium: '200', small: '100', xsmall: '00' },
  detail: { large: '300', medium: '200', small: '100', xsmall: '00' },
};

const LINE_HEIGHT = {
  poster: [114, 113.5, 112, 110, 108, 106, 104, 102, 100, 98, 96, 94, 92],
  display: [124.5, 124, 123.5, 122.5, 121, 119.5, 117.5, 115.5, 114, 112, 110, 108, 106],
  headline: [120.5, 120, 119.5, 118.5, 116.5, 115, 112, 109, 108, 106, 104, 102, 100],
  title: [129, 129, 128, 125, 122, 121.5, 120.5, 118.5, 116.5, 114, 112, 110, 108],
  body: [137.5, 140, 138, 135, 134, 132.5, 130.5, 128, 125, 122.5, 120, 117.5, 115],
  label: [137.5, 140, 138, 135, 134, 132.5, 130.5, 128, 125, 122.5, 120, 117.5, 115],
  detail: [131.5, 133, 131, 127.5, 127, 126.5, 125.5, 124, 122, 119.5, 117, 114.5, 112],
};

const LETTER_SPACING = {
  poster: {
    none: [
      [0.37, -0.13],
      [0.2, -0.3],
      [0.05, -0.45],
      [-0.2, -0.7],
      [-0.63, -1.38],
      [-1.11, -1.86],
      [-1.68, -2.43],
      [-1.97, -2.72],
      [-2.38, -3.13],
      [-2.67, -3.42],
      [-2.86, -3.61],
      [-3.04, -3.79],
      [-3.28, -4.03],
    ],
    uppercase: [
      [4.9, 4.4],
      [4.63, 4.13],
      [4.38, 3.88],
      [4.03, 3.53],
      [3.5, 2.75],
      [2.92, 2.17],
      [2.25, 1.5],
      [1.86, 1.11],
      [1.35, 0.6],
      [0.96, 0.21],
      [0.67, -0.08],
      [0.44, -0.31],
      [0.15, -0.6],
    ],
  },
  display: {
    none: [
      [0.7, 0.2],
      [0.55, 0.05],
      [0.42, -0.08],
      [0.2, -0.3],
      [-0.21, -0.96],
      [-0.67, -1.42],
      [-1.22, -1.97],
      [-1.48, -2.23],
      [-1.87, -2.62],
      [-2.14, -2.89],
      [-2.31, -3.06],
      [-2.46, -3.21],
      [-2.68, -3.43],
    ],
    uppercase: [
      [3.29, 2.79],
      [3.04, 2.54],
      [2.81, 2.31],
      [2.49, 1.99],
      [1.93, 1.18],
      [1.32, 0.57],
      [0.67, -0.08],
      [0.26, -0.49],
      [-0.23, -0.98],
      [-0.65, -1.4],
      [-0.92, -1.67],
      [-1.17, -1.92],
      [-1.49, -2.24],
    ],
  },
  headline: {
    none: [
      [-0.75, -1.25],
      [-0.87, -1.37],
      [-0.97, -1.47],
      [-1.15, -1.65],
      [-1.38, -2.13],
      [-1.62, -2.37],
      [-1.85, -2.6],
      [-2.11, -2.86],
      [-2.69, -3.44],
      [-3.02, -3.77],
      [-3.22, -3.97],
      [-3.41, -4.16],
      [-3.67, -4.42],
    ],
    uppercase: [
      [0.95, 0.45],
      [0.73, 0.23],
      [0.53, 0.03],
      [0.2, -0.3],
      [-0.18, -0.93],
      [-0.57, -1.32],
      [-0.95, -1.7],
      [-1.31, -2.06],
      [-2.04, -2.79],
      [-2.52, -3.27],
      [-2.87, -3.62],
      [-3.16, -3.91],
      [-3.52, -4.27],
    ],
  },
  title: {
    none: [
      [0.45, -0.05],
      [0.36, -0.14],
      [0.28, -0.22],
      [0.15, -0.35],
      [0, -0.75],
      [-0.07, -0.82],
      [-0.25, -1],
      [-0.38, -1.13],
      [-0.69, -1.44],
      [-0.99, -1.74],
      [-1.16, -1.91],
      [-1.31, -2.06],
      [-1.53, -2.28],
    ],
    uppercase: [
      [2.45, 1.95],
      [2.21, 1.71],
      [2.03, 1.53],
      [1.75, 1.25],
      [1.45, 0.7],
      [1.23, 0.48],
      [0.9, 0.15],
      [0.62, -0.13],
      [0.16, -0.59],
      [-0.29, -1.04],
      [-0.61, -1.36],
      [-0.91, -1.66],
      [-1.28, -2.03],
    ],
  },
  body: {
    none: [
      [-0.27, -0.77],
      [-0.33, -0.83],
      [-0.38, -0.88],
      [-0.42, -0.92],
      [-0.47, -1.22],
      [-0.45, -1.2],
      [-0.42, -1.17],
      [-0.4, -1.15],
      [-0.35, -1.1],
      [-0.29, -1.04],
      [-0.26, -1.01],
      [-0.23, -0.98],
      [-0.18, -0.93],
    ],
    uppercase: [
      [1.88, 1.38],
      [1.72, 1.22],
      [1.52, 1.02],
      [1.33, 0.83],
      [1.13, 0.38],
      [1, 0.25],
      [0.88, 0.13],
      [0.75, 0],
      [0.65, -0.1],
      [0.56, -0.19],
      [0.44, -0.31],
      [0.32, -0.43],
      [0.22, -0.53],
    ],
  },
  label: {
    none: [
      [0.3, -0.2],
      [0.24, -0.26],
      [0.19, -0.31],
      [0.1, -0.4],
      [0.08, -0.67],
      [0.13, -0.62],
      [0.19, -0.56],
      [0.22, -0.53],
      [0.27, -0.48],
      [0.33, -0.42],
      [0.36, -0.39],
      [0.39, -0.36],
      [0.44, -0.31],
    ],
    uppercase: [
      [7.4, 7],
      [7.1, 6.7],
      [6.8, 6.4],
      [6.4, 6],
      [6, 5.6],
      [5.6, 5.2],
      [5.2, 4.8],
      [4.8, 4.4],
      [4.3, 3.9],
      [3.8, 3.4],
      [3.4, 3],
      [3, 2.6],
      [2.6, 2.2],
    ],
  },
  detail: {
    none: [
      [0.52, 0.02],
      [0.44, -0.06],
      [0.38, -0.12],
      [0.31, -0.19],
      [0.23, -0.52],
      [0.22, -0.53],
      [0.17, -0.58],
      [0.14, -0.61],
      [0.06, -0.69],
      [0, -0.75],
      [-0.04, -0.79],
      [-0.07, -0.82],
      [-0.12, -0.87],
    ],
    uppercase: [
      [2.92, 2.42],
      [2.74, 2.24],
      [2.53, 2.03],
      [2.31, 1.81],
      [2.03, 1.28],
      [1.82, 1.07],
      [1.62, 0.87],
      [1.44, 0.69],
      [1.21, 0.46],
      [1, 0.25],
      [0.76, 0.01],
      [0.58, -0.17],
      [0.38, -0.37],
    ],
  },
};

const SCRIPTS = {
  ko: {
    sizeScale: [
      1.1, 1.09, 1.07, 1.06, 1.058, 1.054, 1.048, 1.042, 1.036, 1.032, 1.03, 1.029, 1.0285,
    ],
    lineHeight: {
      poster: [116, 115.5, 114, 112, 110, 108, 106, 104, 102, 100, 98, 96, 94],
      display: [126.5, 126, 125.5, 124.5, 123, 121.5, 119.5, 117.5, 116, 114, 112, 110, 108],
      headline: [122.5, 122, 121.5, 120.5, 118.5, 117, 114, 111, 110, 108, 106, 104, 102],
      title: [133, 133, 132, 129, 126, 125.5, 124.5, 122.5, 120.5, 118, 116, 114, 112],
      body: [138, 138, 144, 140, 139.5, 139.5, 139, 138, 136, 133, 130, 127, 124],
      label: [138, 138, 144, 140, 139.5, 139.5, 139, 138, 136, 133, 130, 127, 124],
      detail: [135.5, 135.5, 138, 137, 136, 135, 133.5, 131.5, 129, 126.5, 124, 121.5, 119],
    },
    letterSpacing: {
      poster: [
        [0.27, 0.07],
        [0.07, -0.13],
        [0, -0.2],
        [-0.13, -0.33],
        [-0.28, -0.58],
        [-0.4, -0.7],
        [-0.46, -0.76],
        [-0.54, -0.84],
        [-0.67, -1.07],
        [-0.76, -1.16],
        [-0.81, -1.21],
        [-0.86, -1.26],
        [-0.92, -1.32],
      ],
      display: [
        [0.43, 0.23],
        [0.25, 0.05],
        [0.19, -0.01],
        [0.07, -0.13],
        [-0.07, -0.37],
        [-0.18, -0.48],
        [-0.23, -0.53],
        [-0.3, -0.6],
        [-0.42, -0.82],
        [-0.49, -0.89],
        [-0.53, -0.93],
        [-0.57, -0.97],
        [-0.62, -1.02],
      ],
      headline: [
        [-0.83, -1.03],
        [-0.8, -1],
        [-0.8, -1],
        [-0.83, -1.03],
        [-0.96, -1.26],
        [-1.05, -1.35],
        [-1.29, -1.59],
        [-1.38, -1.68],
        [-1.46, -1.86],
        [-1.54, -1.94],
        [-1.57, -1.97],
        [-1.58, -1.98],
        [-1.61, -2.01],
      ],
      title: [
        [0.39, 0.19],
        [0.44, 0.24],
        [0.47, 0.27],
        [0.42, 0.22],
        [0.24, -0.06],
        [0.09, -0.21],
        [0.04, -0.26],
        [0, -0.3],
        [-0.01, -0.41],
        [-0.06, -0.46],
        [-0.05, -0.45],
        [-0.05, -0.45],
        [-0.04, -0.44],
      ],
      body: [
        [-0.21, -0.41],
        [-0.29, -0.49],
        [-0.37, -0.57],
        [-0.54, -0.74],
        [-0.67, -0.97],
        [-0.68, -0.98],
        [-0.66, -0.96],
        [-0.67, -0.97],
        [-0.65, -1.05],
        [-0.64, -1.04],
        [-0.63, -1.03],
        [-0.63, -1.03],
        [-0.62, -1.02],
      ],
      label: [
        [0.85, 0.65],
        [0.81, 0.61],
        [0.71, 0.51],
        [0.54, 0.34],
        [0.27, -0.03],
        [0.23, -0.07],
        [0.25, -0.05],
        [0.26, -0.04],
        [0.27, -0.13],
        [0.26, -0.14],
        [0.26, -0.14],
        [0.26, -0.14],
        [0.26, -0.14],
      ],
      detail: [
        [0.53, 0.33],
        [0.5, 0.3],
        [0.46, 0.26],
        [0.33, 0.13],
        [0.18, -0.12],
        [0.12, -0.18],
        [0.12, -0.18],
        [0.1, -0.2],
        [0.11, -0.29],
        [0.1, -0.3],
        [0.11, -0.29],
        [0.11, -0.29],
        [0.12, -0.28],
      ],
    },
  },
  ja: {
    sizeScale: [1, 0.97, 0.971, 0.94, 0.946, 0.96, 0.979, 1.001, 1.02, 1.034, 1.04, 1.0426, 1.0437],
    lineHeight: {
      poster: [117, 116.5, 115, 113, 111, 109, 107, 105, 103, 101, 99, 97, 95],
      display: [127.5, 127, 126.5, 125.5, 124, 122.5, 120.5, 118.5, 117, 115, 113, 111, 109],
      headline: [129.5, 129, 128.5, 127.5, 125.5, 124, 121, 118, 117, 115, 113, 111, 109],
      title: [140, 140, 139, 136, 133, 132.5, 131.5, 129.5, 127.5, 125, 123, 121, 119],
      body: [148, 150, 158, 154, 153.5, 153.5, 153, 152, 150, 147, 144, 141, 138],
      label: [148, 150, 158, 154, 153.5, 153.5, 153, 152, 150, 147, 144, 141, 138],
      detail: [144.5, 146, 151, 150, 149, 147.5, 146, 143.5, 141, 138.5, 136, 133.5, 131],
    },
    letterSpacing: {
      poster: [
        [0.09, -0.11],
        [-0.01, -0.21],
        [-0.1, -0.3],
        [-0.2, -0.4],
        [-0.35, -0.65],
        [-0.48, -0.78],
        [-0.65, -0.95],
        [-0.86, -1.16],
        [-1.13, -1.53],
        [-1.31, -1.71],
        [-1.39, -1.79],
        [-1.48, -1.88],
        [-1.59, -1.99],
      ],
      display: [
        [0.25, 0.05],
        [0.17, -0.03],
        [0.09, -0.11],
        [0, -0.2],
        [-0.14, -0.44],
        [-0.26, -0.56],
        [-0.42, -0.72],
        [-0.62, -0.92],
        [-0.88, -1.28],
        [-1.04, -1.44],
        [-1.11, -1.51],
        [-1.19, -1.59],
        [-1.29, -1.69],
      ],
      headline: [
        [0.12, -0.08],
        [0.09, -0.11],
        [0.03, -0.17],
        [-0.03, -0.23],
        [-0.15, -0.45],
        [-0.37, -0.67],
        [-0.78, -1.08],
        [-1.07, -1.37],
        [-1.28, -1.68],
        [-1.39, -1.79],
        [-1.43, -1.83],
        [-1.46, -1.86],
        [-1.5, -1.9],
      ],
      title: [
        [1.25, 1.05],
        [1.23, 1.03],
        [1.22, 1.02],
        [1.19, 0.99],
        [0.74, 0.44],
        [0.34, 0.04],
        [0.16, -0.14],
        [0.12, -0.18],
        [0.06, -0.34],
        [0.01, -0.39],
        [-0.01, -0.41],
        [-0.03, -0.43],
        [-0.06, -0.46],
      ],
      body: [
        [0.18, -0.02],
        [0, -0.2],
        [-0.2, -0.4],
        [-0.43, -0.63],
        [-0.7, -1],
        [-0.72, -1.02],
        [-0.72, -1.02],
        [-0.7, -1],
        [-0.68, -1.08],
        [-0.66, -1.06],
        [-0.66, -1.06],
        [-0.65, -1.05],
        [-0.64, -1.04],
      ],
      label: [
        [1.83, 1.63],
        [1.6, 1.4],
        [1.34, 1.14],
        [1.06, 0.86],
        [0.64, 0.34],
        [0.34, 0.04],
        [0.35, 0.05],
        [0.35, 0.05],
        [0.34, -0.06],
        [0.32, -0.08],
        [0.32, -0.08],
        [0.31, -0.09],
        [0.3, -0.1],
      ],
      detail: [
        [1.09, 0.89],
        [0.96, 0.76],
        [0.83, 0.63],
        [0.67, 0.47],
        [0.34, 0.04],
        [0.18, -0.12],
        [0.12, -0.18],
        [0.12, -0.18],
        [0.11, -0.29],
        [0.11, -0.29],
        [0.1, -0.3],
        [0.1, -0.3],
        [0.1, -0.3],
      ],
    },
  },
};

const WEIGHT = {
  regular: {
    poster: 500,
    display: 500,
    headline: 500,
    title: 500,
    body: 500,
    label: 500,
    detail: 400,
  },
  emphasis: {
    poster: 900,
    display: 700,
    headline: 700,
    title: 700,
    body: 700,
    label: 700,
    detail: 400,
  },
};

const em = percent => `${(percent / 100).toFixed(4)}em`;

export const type = (role, size, { emphasis = false, uppercase = false } = {}) => {
  const token = SIZE_MAP[role][size];
  const index = TOKENS.indexOf(token);
  const lineHeight = LINE_HEIGHT[role][index];
  const spacing = LETTER_SPACING[role][uppercase ? 'uppercase' : 'none'][index][emphasis ? 1 : 0];
  const weight = WEIGHT[emphasis ? 'emphasis' : 'regular'][role];
  const variant = emphasis ? 'e' : 'r';

  return css`
    font-family: var(--ff-sans);
    font-size: var(--size-${token});
    font-weight: ${weight};
    line-height: var(--lh-${role}-${token}, ${lineHeight}%);
    letter-spacing: var(--ls-${role}-${token}-${variant}, ${em(spacing)});
    ${uppercase ? 'text-transform: uppercase;' : ''}
  `;
};

const LEGACY_SIZES = {
  xs: '00',
  base: '100',
  focus: '200',
  s: '300',
  sm: '400',
  m: '500',
  ml: '600',
  l: '700',
  xl: '900',
  xxl: '1000',
  xxxl: '1100',
};

export const legacyType = (
  fs,
  role = 'body',
  { emphasis = false, uppercase = false, lineHeight = true } = {}
) => {
  const index = TOKENS.indexOf(LEGACY_SIZES[fs]);
  const spacing = LETTER_SPACING[role][uppercase ? 'uppercase' : 'none'][index][emphasis ? 1 : 0];

  return css`
    ${lineHeight ? `line-height: ${LINE_HEIGHT[role][index] / 100};` : ''}
    letter-spacing: ${em(spacing)};
  `;
};

const scriptVariables = script => {
  const { sizeScale, lineHeight, letterSpacing } = SCRIPTS[script];
  const sizes = TOKENS.map((token, i) => `--size-scale-${token}: ${sizeScale[i]};`);
  const roles = Object.keys(SIZE_MAP).map(role =>
    Object.keys(SIZE_MAP[role])
      .map(size => {
        const token = SIZE_MAP[role][size];
        const i = TOKENS.indexOf(token);
        const [regular, emphasis] = letterSpacing[role][i];
        return [
          `--lh-${role}-${token}: ${lineHeight[role][i]}%;`,
          `--ls-${role}-${token}-r: ${em(regular)};`,
          `--ls-${role}-${token}-e: ${em(emphasis)};`,
        ].join('\n');
      })
      .join('\n')
  );
  return [...sizes, ...roles].join('\n');
};

export const scriptTypography = css`
  :root:lang(ko) {
    ${scriptVariables('ko')}
  }

  :root:lang(ja) {
    ${scriptVariables('ja')}
  }
`;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/styles/typography.js